import { type ReactNode } from 'react';

type Tone = 'neutral' | 'danger' | 'lock' | 'success';

interface ITabMessageProps {
	icon: ReactNode;
	tone?: Tone;
	title: string;
	hint?: string;
	action?: { label: string; onClick: () => void } | { label: string; href: string };
}

/** Centered empty / error / locked state shared across the coverage tabs. */
const TabMessage = ({ icon, tone = 'neutral', title, hint, action }: ITabMessageProps) => (
	<div className='ca-state'>
		<span
			className={`ca-state__icon ca-state__icon--${tone}`}
			aria-hidden='true'
		>
			{icon}
		</span>
		<p className='ca-state__title'>{title}</p>
		{hint ? <p className='ca-state__hint'>{hint}</p> : null}
		{action && 'href' in action ? (
			<a
				className='ca-state__action'
				href={action.href}
			>
				{action.label}
			</a>
		) : null}
		{action && 'onClick' in action ? (
			<button
				type='button'
				className='ca-state__action'
				onClick={action.onClick}
			>
				{action.label}
			</button>
		) : null}
	</div>
);

export default TabMessage;
